import { applicationModuleRegistry } from '@philips-internal/oswald-ui-foundation';

import { KpiOpenedRoutesApplication } from '../../constants';

function setupOsOpenedGraphics(): void {
  applicationModuleRegistry.register({
    closeable: true,
    entry: 'os-opened-graphics',
    id: 'os-opened-graphics',
    name: 'kpi-opened-graphics.title',
    route: KpiOpenedRoutesApplication.OS_OPENED_GRAPHICS,
  });
}

export {
  setupOsOpenedGraphics,
};
